import { render, staticRenderFns } from "./UCProductHeading.vue?vue&type=template&id=42b219b2&scoped=true&"
import script from "./UCProductHeading.vue?vue&type=script&lang=ts&"
export * from "./UCProductHeading.vue?vue&type=script&lang=ts&"
import style0 from "./UCProductHeading.vue?vue&type=style&index=0&id=42b219b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b219b2",
  null
  
)

export default component.exports